import * as Yup from 'yup';

export const buildWorksheetRangeSchema = ({
  fromKey,
  toKey,
  minKey,
  maxKey,
  modulesPerWeekKey,
  minModulesPerWeek,
  fromLabel = 'Worksheet FROM',
  toLabel = 'Worksheet TO',
}) => {
  const fromSchema = Yup.number().when(modulesPerWeekKey, {
    is: (val) => val >= minModulesPerWeek,
    then: (schema) =>
      schema
        .typeError(`${fromLabel} must be a number`)
        .required(`Please enter ${fromLabel}`)
        .test('range-from', '', function (value) {
          const parent = this.parent || {};
          const min = parent[minKey];
          const max = parent[maxKey];
          const to = parent[toKey];

          // let "required" handle empty
          if (value === undefined || value === null) return true;

          const num = Number(value);
          if (Number.isNaN(num)) {
            return this.createError({
              message: `${fromLabel} must be a number`,
            });
          }

          const minNum =
            min !== undefined && min !== null && min !== ''
              ? Number(min)
              : undefined;
          const maxNum =
            max !== undefined && max !== null && max !== ''
              ? Number(max)
              : undefined;

          if (minNum !== undefined && !Number.isNaN(minNum) && num < minNum) {
            return this.createError({
              message: `${fromLabel} must be ≥ ${minNum}`,
            });
          }

          if (maxNum !== undefined && !Number.isNaN(maxNum) && num > maxNum) {
            return this.createError({
              message: `${fromLabel} must be ≤ ${maxNum}`,
            });
          }

          if (
            to !== undefined &&
            to !== null &&
            to !== '' &&
            num >= Number(to)
          ) {
            return this.createError({
              message: `${fromLabel} must be less than ${toLabel}`,
            });
          }

          return true;
        }),
    otherwise: (schema) => schema, // module not active → no extra rules
  });

  const toSchema = Yup.number().when(modulesPerWeekKey, {
    is: (val) => val >= minModulesPerWeek,
    then: (schema) =>
      schema
        .typeError(`${toLabel} must be a number`)
        .required(`Please enter ${toLabel}`)
        .test('range-to', '', function (value) {
          const parent = this.parent || {};
          const min = parent[minKey];
          const max = parent[maxKey];
          const from = parent[fromKey];
          
          if (value === undefined || value === null) return true;

          const num = Number(value);
          if (Number.isNaN(num)) {
            return this.createError({
              message: `${toLabel} must be a number`,
            });
          }

          const minNum =
            min !== undefined && min !== null && min !== ''
              ? Number(min)
              : undefined;
          const maxNum =
            max !== undefined && max !== null && max !== ''
              ? Number(max)
              : undefined;

          if (minNum !== undefined && !Number.isNaN(minNum) && num < minNum) {
            return this.createError({
              message: `${toLabel} must be ≥ ${minNum}`,
            });
          }

          if (maxNum !== undefined && !Number.isNaN(maxNum) && num > maxNum) {
            return this.createError({
              message: `${toLabel} must be ≤ ${maxNum}`,
            });
          }

          if (
            from !== undefined &&
            from !== null &&
            from !== '' &&
            num <= Number(from)
          ) {
            return this.createError({
              message: `${toLabel} must be greater than ${fromLabel}`,
            });
          }

          return true;
        }),
    otherwise: (schema) => schema,
  });

  return {
    [fromKey]: fromSchema,
    [toKey]: toSchema,
  };
};
